import { render } from "./Value.vue?vue&type=template&id=5235c516&scoped=true"
import script from "./Value.vue?vue&type=script&lang=js"
export * from "./Value.vue?vue&type=script&lang=js"

import "./Value.vue?vue&type=style&index=0&id=5235c516&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5235c516"]])

export default __exports__